import {useTranslation} from 'react-i18next';

import {getAssetFeedSubtitle} from '@/features/buyers/utils';
import {useTrustTypeStrategy} from '@/features/trust-accounts/providers';

import {ActivityFeedRowLayout} from '../ActivityFeedRowLayout';
import {BuyerNamesSummary} from './BuyerNamesSummary';
import {castMetadata, readAssetSummary, readBuyerNames} from './metadata.utils';

import type {BuyerRemovedMetadata, TrustAccountActivityDTO} from '@sollapay/types';

interface BuyerRemovedRowProps {
  activity: TrustAccountActivityDTO;
}

export function BuyerRemovedRow({activity}: BuyerRemovedRowProps) {
  const {t} = useTranslation('trustAccounts');
  const {allowsMultipleAssets} = useTrustTypeStrategy();
  const meta = castMetadata<BuyerRemovedMetadata>(activity);
  const asset = readAssetSummary(activity);
  const buyerNames = readBuyerNames(meta);

  return (
    <ActivityFeedRowLayout
      icon="sollapay:remove-buyer"
      title={t('view.activity.activityType.buyer_removed')}
      subtitle={getAssetFeedSubtitle(asset, t, allowsMultipleAssets)}
      actorName={buyerNames.length > 0 ? <BuyerNamesSummary buyerNames={buyerNames} /> : null}
      createdAt={activity.createdAt}
    />
  );
}
